import { ApolloLink } from '@apollo/client';
import { datadogLogs } from '@datadog/browser-logs';
import { map } from 'rxjs/operators';

export const roundTripLink = new ApolloLink((operation, forward) => {
  const start = Date.now();
  operation.setContext({ start });

  return forward(operation).pipe(
    map(data => {
      const end = Date.now();
      const time = end - operation.getContext().start;

      datadogLogs.logger.info('WebGraphQLLatencyMetric', {
        ...operation,
        latency: { start, end, time },
      });
      return data;
    })
  );
});
